module.exports = __webpack_public_path__ + "static/media/Ads Logo_DarkMode.26d494d5.svg";